/*
 * @Author: 田鑫
 * @Date: 2022-01-06 10:29:18
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-17 18:28:00
 * @Description: 年夜饭预定
 */
export default [
  {
    name: "chefManagement",
    path: "/supplySystem/:supplyId/reunionDinnerManagement/chefLabelManagement",
    meta: { title: "厨师标签管理" },
    component: require("business/supplySystem/reunionDinnerManagement/chefLabelManagement/list.vue")
      .default
  },
  {
    name: "chefManagement",
    path: "/supplySystem/:supplyId/reunionDinnerManagement/chefManagement",
    meta: { title: "厨师管理" },
    component: require("business/supplySystem/reunionDinnerManagement/chefManagement/list.vue")
      .default
  },
  {
    name: "restaurantManagement",
    path:
      "/supplySystem/:supplyId/reunionDinnerManagement/restaurantManagement",
    meta: { title: "餐厅管理" },
    component: require("business/supplySystem/reunionDinnerManagement/restaurantManagement/list.vue")
      .default
  },
  {
    name: "addDishroomManagement",
    path:
      "/supplySystem/:supplyId/reunionDinnerManagement/restaurantManagement/addDishroom",
    meta: { title: "新增包间" },
    component: require("business/supplySystem/reunionDinnerManagement/restaurantManagement/dishRoom.vue")
      .default
  },
  {
    name: "dishRoomsManagement",
    path: "/supplySystem/:supplyId/reunionDinnerManagement/dishRoomsManagement",
    meta: { title: "包间管理" },
    component: require("business/supplySystem/reunionDinnerManagement/dishRoomsManagement/list.vue")
      .default
  },
  {
    name: "hotelRoomManagement",
    path: "/supplySystem/:supplyId/reunionDinnerManagement/hotelRoomManagement",
    meta: { title: "客房管理" },
    component: require("business/supplySystem/reunionDinnerManagement/dishRoomsManagement/hotelRoom.vue")
      .default
  },
  {
    name: "reunionTimeManagement",
    path:
      "/supplySystem/:supplyId/reunionDinnerManagement/reunionTimeManagement",
    meta: { title: "年夜饭时段管理" },
    component: require("business/supplySystem/reunionDinnerManagement/reunionTimeManagement/list.vue")
      .default
  },
  {
    name: "reunionPreOrderManagement",
    path:
      "/supplySystem/:supplyId/reunionDinnerManagement/reunionPreOrderManagement",
    meta: { title: "年夜饭预定订单管理" },
    component: require("business/supplySystem/reunionDinnerManagement/reunionPreOrderManagement/list.vue")
      .default
  },
  {
    name: "reunionPreOrderDetail",
    path:
      "/supplySystem/:supplyId/reunionDinnerManagement/reunionPreOrderDetail",
    meta: { title: "年夜饭预定订单详情" },
    component: require("business/supplySystem/reunionDinnerManagement/reunionPreOrderManagement/detail.vue")
      .default
  }
];
